import {FilterMatchMode, FilterOperator} from "primereact/api";
import {
    CLEAR_STATUSES_BY_PERIOD_FILTERS,
    SET_STATUSES_BY_PERIOD_UI_FILTERS,
    GET_STATUS_BY_PERIOD,
    GET_STATUSES_BY_PERIOD_LIST,
    GET_STATUSES_BY_PERIOD_PAGINATION, INITIAL_STATUSES_BY_PERIOD_DATA,
    SELECTED_STATUSES_BY_PERIOD_ID,
    SET_CURRENT_STATUSES_BY_PERIOD_PAGE,
    SET_CURRENT_STATUSES_BY_PERIOD_SIZE, SET_STATUSES_BY_PERIOD_FILTER,
    SET_STATUSES_BY_PERIOD_LOADING, SHOW_EXPORT_STATUSES_BY_PERIOD_LOADING,
    GET_FILES_HISTORY,
    UPDATE_FILES_HISTORY,
    SET_FILES_HISTORY_LOADER,
    GET_FILES_PAGINATION,
    SET_CURRENT_FILES_PAGE,
    SET_CURRENT_FILES_SIZE
} from "../types/typesStatusesByPeriodList";
import {HIDE_LOADER} from "../types/types";

const initialState = {
    selectedStatusByPeriodId: null,
    clearFilters: {
        id: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        status: {value: null, matchMode: FilterMatchMode.IN},
        statusName: {value: null, matchMode: FilterMatchMode.IN},
        typeChannel: {value: null, matchMode: FilterMatchMode.IN},
        start: {value: null, matchMode: FilterMatchMode.IN},
        duration: {value: null, matchMode: FilterMatchMode.IN},
        end: {value: null, matchMode: FilterMatchMode.IN},
        timeEnd: {value: null, matchMode: FilterMatchMode.IN},
        timeInStatus: {value: null, matchMode: FilterMatchMode.IN},
        changeType: {value: null, matchMode: FilterMatchMode.IN},
    },
    statusesByPeriodList: [],
    pagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    statusByPeriodData: {
        id: 3174153,
        timeStart: null,
        timeEnd: null,
        statusId: null,
        statusName: null,
        userName: null,
        statusColor: null,
        changeType: null,
        timeInStatus: null
    },
    loading: false,
    exportLoading: false,
    detailsLoading: false,
    error: false,
    errorFields: null,
    pageChanged: false,
    dataSort: null,
    filesHistory: [],
    filesHistoryLoader: false,
    // Отдельная пагинация для файлов
    filesPagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    filesPaginationPage: 1,
    filesPaginationSize: 10
}

export const StatusesByPeriodListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SELECTED_STATUSES_BY_PERIOD_ID:
            return {...state, selectedStatusByPeriodId: action.payload}
        case CLEAR_STATUSES_BY_PERIOD_FILTERS:
            return {
                ...state, clearFilters: {
                    id: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    status: {value: null, matchMode: FilterMatchMode.IN},
                    statusName: {value: null, matchMode: FilterMatchMode.IN},
                    typeChannel: {value: null, matchMode: FilterMatchMode.IN},
                    start: {value: null, matchMode: FilterMatchMode.IN},
                    duration: {value: null, matchMode: FilterMatchMode.IN},
                    end: {value: null, matchMode: FilterMatchMode.IN},
                    timeEnd: {value: null, matchMode: FilterMatchMode.IN},
                    timeInStatus: {value: null, matchMode: FilterMatchMode.IN},
                    changeType: {value: null, matchMode: FilterMatchMode.IN},
                }
            }
        case SET_STATUSES_BY_PERIOD_UI_FILTERS: {
            const nextFilters = { ...state.clearFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearFilters: nextFilters
            };
        }
        case GET_STATUSES_BY_PERIOD_LIST:
            return {...state, statusesByPeriodList: action.payload}
        case GET_STATUSES_BY_PERIOD_PAGINATION:
            return {...state, pagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_STATUSES_BY_PERIOD_PAGE:
            return {...state, paginationPage: action.payload}
        case SET_CURRENT_STATUSES_BY_PERIOD_SIZE:
            return {...state, paginationSize: action.payload}
        case GET_STATUS_BY_PERIOD:
            return {...state, statusByPeriodData: action.payload}
        case SET_STATUSES_BY_PERIOD_LOADING:
            return {...state, loading: action.payload}
        case HIDE_LOADER:
            return {...state, loading: false}
        case INITIAL_STATUSES_BY_PERIOD_DATA:
            return {...state, statisticStatusData: initialState.statusByPeriodData}
        case SHOW_EXPORT_STATUSES_BY_PERIOD_LOADING:
            return {...state, exportLoading: action.payload}
        case SET_STATUSES_BY_PERIOD_FILTER:
            return {...state, dataSort: action.payload}
        case GET_FILES_HISTORY:
            return {...state, filesHistory: action.payload};
        case UPDATE_FILES_HISTORY:
            return {
                ...state,
                filesHistory: [action.payload, ...(state.filesHistory || [])]
            };
        case SET_FILES_HISTORY_LOADER:
            return {...state, filesHistoryLoader: action.payload}
        case GET_FILES_PAGINATION:
            return {...state, filesPagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_FILES_PAGE:
            return {...state, filesPaginationPage: action.payload}
        case SET_CURRENT_FILES_SIZE:
            return {...state, filesPaginationSize: action.payload}
        default:
            return state
    }
}
